import { Box, Card, Skeleton } from "@mui/material";

export default function CardSkeleton() {
  return (
    <Card
      sx={{
        display: "flex",
        padding: 2,
        gap: 2,
        borderRadius: 3,
        marginBottom: 3,
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width="60%" height={30} />
        <Skeleton variant="text" width="40%" height={20} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="80%" height={20} />
        <Skeleton variant="text" width="30%" height={20} sx={{ mt: 1 }} />
        <Skeleton variant="text" width="15%" height={30} sx={{ mt: 2 }} />
      </Box>

      <Skeleton variant="rounded" width={120} height={160} />
    </Card>
  );
}
